import { render, staticRenderFns } from "./unpendingDialog.vue?vue&type=template&id=9b10d6ec"
import script from "./unpendingDialog.vue?vue&type=script&lang=ts"
export * from "./unpendingDialog.vue?vue&type=script&lang=ts"
import style0 from "./unpendingDialog.vue?vue&type=style&index=0&id=9b10d6ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports